const MAX_TEXTURE_EDGE = 2048
const ACCEPTED_IMAGE_TYPES = new Set(['image/jpeg', 'image/png'])

function fitWithin(width, height, maxEdge = MAX_TEXTURE_EDGE) {
  const scale = Math.min(1, maxEdge / Math.max(width, height))
  return { width: Math.max(1, Math.round(width * scale)), height: Math.max(1, Math.round(height * scale)) }
}

function canvasToGraphic(canvas, file, sourceType) {
  return {
    name: file.name,
    sourceType,
    mimeType: 'image/jpeg',
    width: canvas.width,
    height: canvas.height,
    dataUrl: canvas.toDataURL('image/jpeg', 0.9),
  }
}

async function imageFileToGraphic(file) {
  const objectUrl = URL.createObjectURL(file)
  try {
    const image = await new Promise((resolve, reject) => {
      const node = new Image()
      node.onload = () => resolve(node)
      node.onerror = () => reject(new Error('Nie udało się odczytać pliku graficznego.'))
      node.src = objectUrl
    })
    const size = fitWithin(image.naturalWidth, image.naturalHeight)
    const canvas = document.createElement('canvas')
    canvas.width = size.width
    canvas.height = size.height
    const context = canvas.getContext('2d')
    context.fillStyle = '#ffffff'
    context.fillRect(0, 0, size.width, size.height)
    context.drawImage(image, 0, 0, size.width, size.height)
    return canvasToGraphic(canvas, file, file.type)
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}

async function pdfFileToGraphic(file) {
  const pdfjs = await import('pdfjs-dist')
  pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()
  const pdfDocument = await pdfjs.getDocument({ data: await file.arrayBuffer() }).promise
  const page = await pdfDocument.getPage(1)
  const baseViewport = page.getViewport({ scale: 1 })
  const scale = Math.min(2, MAX_TEXTURE_EDGE / Math.max(baseViewport.width, baseViewport.height))
  const viewport = page.getViewport({ scale })
  const canvas = document.createElement('canvas')
  canvas.width = Math.max(1, Math.round(viewport.width))
  canvas.height = Math.max(1, Math.round(viewport.height))
  const context = canvas.getContext('2d')
  context.fillStyle = '#ffffff'
  context.fillRect(0, 0, canvas.width, canvas.height)
  await page.render({ canvasContext: context, viewport }).promise
  return canvasToGraphic(canvas, file, 'application/pdf')
}

export async function fileToGraphic(file) {
  if (!file) throw new Error('Nie wybrano pliku grafiki.')
  const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
  if (isPdf) return pdfFileToGraphic(file)
  if (ACCEPTED_IMAGE_TYPES.has(file.type) || /\.(jpe?g|png)$/i.test(file.name)) return imageFileToGraphic(file)
  throw new Error('Obsługiwane formaty grafiki: PDF, JPG i PNG.')
}
